var map = {
	"./bugreport.json": 66961,
	"./careprovider.json": 22173,
	"./common.json": 37481,
	"./contact.json": 47865,
	"./forms.json": 60499,
	"./imprint.json": 38493,
	"./infrastructure.json": 17171,
	"./population.json": 92017,
	"./privacy.json": 23329,
	"./privatemenu.json": 70605,
	"./profile.json": 40854,
	"./register.json": 36006,
	"./scenarios.json": 51836,
	"./services.json": 41551,
	"./team.json": 7863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54798;